<template>
  <div class="container-desktop d-flex align-items-center h-100 text-center">
    <div class="w-100">
      <figure class="mb-5">
        <img alt="Iqos Pocket" src="@/assets/logo.png" />
      </figure>
      <div class="d-flex justify-content-center">
        <div class="align-self-center p-4 text-left">
          <p>
            Această pagină poate fi vizualizată
            <br />doar pe dispozitive mobile.
          </p>
          <p>
            Te rugăm să accesezi
            <strong>IQOS POCKET</strong>
            <br />de pe smartphone-ul tău!
          </p>
        </div>
        <div class="align-self-center p-4">
          <img class="img-tel-desktop" alt src="@/assets/icon-tel-2.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Desktop"
};
</script>
